module.exports = __webpack_public_path__ + "img/1871.26db73e5.gif";